(function () {
    'use strict';

    angular
        .module('BCMControllers', ['services.language']);

    /**
     * Defines all the types used in the module, for ease of validation and auto-complete
     *
     * => BIA Responsibility Container
     * @typedef {object} BIAResponsibilityContainer
     * @property {BIAResponsibility} BIAResponsibility
     * @property {BIAKeyPerson[]} BIAKeyPersons
     * @property {string} ComplianceImpactDetails
     * @property {string} FinancialImpactDetails
     * @property {boolean} HasFinancialImpact
     * @property {boolean} HasOperationalImpact
     * @property {boolean} HasComplianceImpact
     * @property {IamSystem[]} IAMSystemList
     * @property {string} OperationalImpactDetails
     * @property {number} OverallImpactLevelID
     * @property {LookupAttributeValue} OverallImpactLevel
     *
     * => BIA Responsibility
     * @typedef {object} BIAResponsibility
     * @property {number} [BIAResponsibilityID]
     * @property {string} TitleEN
     * @property {string} Description
     * @property {number} [BIAProfileID]
     * @property {BIAProfile} [BIAProfile]
     * @property {number} [PRCResponsibilityID]
     * @property {Responsibility} [PRCResponsibility]
     * @property {number} [BCMResponsibilityID]
     * @property {BCMResponsibility} [BCMResponsibility]
     *
     * @property {string} TimeFrame
     * @property {string} CriticalPeriod
     * @property {number} [OffSiteExecutionID]
     * @property {number} [OperationalWorkaroundID]
     * @property {boolean} HasExecutionPlan
     *
     * @property {number} [FinancialImpact]
     * @property {string} FinancialImpactDetails
     * @property {number} [OperationalImpact]
     * @property {string} OperationalImpactDetails
     * @property {number} [ComplianceImpact]
     * @property {string} ComplianceImpactDetails
     * @property {number} [OverallImpact]
     * @property {string} OverallImpactDetails
     * @property {boolean} IsRated
     * @property {boolean} HasImpactDetails
     *
     * @property {number} [PriorityLevelID]
     *
     * => BIA Key Person
     * @typedef {object} BIAKeyPerson
     * @property {number} [PersonID]
     * @property {Person} [Person]
     * @property {number} [BIAKeyPersonID]
     * @property {number} [RoleID]
     * @property {number} [BIAResponsibilityID]
     * @property {BIAResponsibility} [BIAResponsibility]
     *
     * => IAM System
     * @typedef {object} IAMSystem
     *
     */

})();